import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
import HomeView from "../view/Home/HomeView.vue";
// import AdminView from '../view/admin/index.vue'
import JionUsView from "../view/JoinUs/JoinUsView.vue";
import AboutUsView from "../view/AboutUs/AboutUsView.vue";
import CoretechnologyView from "../view/Coretechnology/CoretechnologyView.vue";
import ProductcenterHiLView from "../view/Productcenter/ProductcenterHiLView.vue";
import ProductcenterSiLView from "../view/Productcenter/ProductcenterSiLView.vue";
import ProductcenterGaiAView from "../view/Productcenter/ProductcenterGaiAView.vue";
import ProductcenterDriveView from "../view/Productcenter/ProductcenterDriveView.vue";
import ProductcenterPDRHeaView from "../view/Productcenter/ProductcenterPDRHeaView.vue";
import ProductcenterMeiDuShaView from "../view/Productcenter/ProductcentermeidushaView.vue";
import productHercules from "../view/Productcenter/productHercules.vue";
import ModelSharePlatformView from "../view/Ecosphere/ModelSharePlatform.vue";
import EcologicalCooperationSharePlatformView from "../view/Ecosphere/EcologicalCooperationSharePlatform.vue";
import FullScaleAutonomousDriving from "../view/FullScaleAutonomousDriving/index.vue";
const routes = [
  // {
  //     path: '/admin/login',
  //     name: 'admin',
  //     component: AdminView,
  //     meta: {
  //         isAuth: true,
  //         title: 'admin',
  //         reload: true
  //     },
  // },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      isAuth: true,
      title: "首页 | 精准仿真引领者",
      reload: true,
    },
  },
  {
    path: "/coretechnology",
    name: "coretechnology",
    component: CoretechnologyView,
    meta: {
      isAuth: true,
      title: "核心技术 | 精准仿真引领者",
    },
  },
  {
    path: "/productGaiA",
    name: "productGaiA",
    component: ProductcenterGaiAView,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productRHea",
    name: "productRHea",
    component: ProductcenterPDRHeaView,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productHiL",
    name: "productHiL",
    component: ProductcenterHiLView,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productRing",
    name: "productRing",
    component: ProductcenterDriveView,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productClound",
    name: "productClound",
    component: ProductcenterSiLView,
    meta: {
      keepAlive: true,
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/PdCloudSiLModuleTwoContent11",
    name: "PdCloudSiLModuleTwoContent11",
    component: ProductcenterSiLView,
    meta: {
      keepAlive: true,
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/PdCloudSiLModuleThree11",
    name: "PdCloudSiLModuleThree11",
    component: ProductcenterSiLView,
    meta: {
      keepAlive: true,
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/PdCloudSiLModuleNine11",
    name: "PdCloudSiLModuleNine11",
    component: ProductcenterSiLView,
    meta: {
      keepAlive: true,
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productMedusa",
    name: "productMedusa",
    component: ProductcenterMeiDuShaView,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productHercules",
    name: "productHercules",
    component: productHercules,
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productUranus",
    name: "productUranus",
    component: () => import("../view/product-uranus/IndexPage.vue"),
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/productRobot",
    name: "productRobot",
    component: () => import("../view/product-robot/IndexPage.vue"),
    meta: {
      isAuth: true,
      title: "产品中心 | 精准仿真引领者",
    },
  },
  {
    path: "/modelSharePlatform",
    name: "modelSharePlatform",
    component: ModelSharePlatformView,
    meta: {
      isAuth: true,
      title: "生态圈 | 精准仿真引领者",
    },
  },
  {
    path: "/ecologicalCooperationSharePlatform",
    name: "ecologicalCooperationSharePlatform",
    component: EcologicalCooperationSharePlatformView,
    meta: {
      isAuth: true,
      title: "生态圈 | 精准仿真引领者",
    },
  },
  {
    path: "/FullScaleAutonomousDriving",
    name: "FullScaleAutonomousDriving",
    component: FullScaleAutonomousDriving,
    meta: {
      isAuth: true,
      title: "生态圈 | 全境智能研发",
    },
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: AboutUsView,
    meta: {
      isAuth: true,
      title: "关于我们 | 精准仿真引领者",
    },
  },
  {
    path: "/joinUs",
    name: "joinUs",
    component: JionUsView,
    meta: {
      isAuth: true,
      title: "加入我们 | 精准仿真引领者",
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});
//避免重复点击导航爆错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  if (to.meta.refresh) {
    to.query.refresh = Date.now();
  }
  next();
});

//切换路由让每一次页面回到顶端
router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
